const LedgerType = Object.freeze({
  SYSTEM: "SYSTEM",
  CLIENT: "CLIENT",
});

export default LedgerType;
